export default __webpack_public_path__ + "static/3-971098d63669fa9e574d219bba98d1a3.png";